<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Situazione Generale" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Colloquio avvenuta con:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.colloquioAvvenutoCon }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.colloquioAvvenutoCon" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Cittadinanza:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.cittadinanza }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.cittadinanza" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Stato civile:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.statoCivile }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.statoCivile" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Eventuale domicilio:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.eventualeDomicilio }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.eventualeDomicilio" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Familiare o persona di riferimento:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.familiareRiferimento }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.familiareRiferimento" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Posizione giuridica:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.posizioneGiuridica }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.posizioneGiuridica" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Persona incaricata:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.personaIncaricata }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.personaIncaricata" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Provvedimenti penali:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.provvedimentiPenali }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.provvedimentiPenali" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Composizione del nucleo familiare:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.composizioneNucleoFamiliare }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.composizioneNucleoFamiliare" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione abitativa:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneGenerale.situazioneAbitativa }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneGenerale.situazioneAbitativa" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataSituazioneGenerale: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    colloquioAvvenutoCon: "",
                    cittadinanza: "",
                    statoCivile: "",
                    eventualeDomicilio: "",
                    familiareRiferimento: "",
                    posizioneGiuridica: "",
                    personaIncaricata: "",
                    provvedimentiPenali: "",
                    composizioneNucleoFamiliare: "",
                    situazioneAbitativa: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataSituazioneGenerale: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaSituazioneGenerale: "/rsaschedarelazionesanitariasituazionegenerale",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaSituazioneGenerale() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaSituazioneGenerale + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaSituazioneGeneraleSuccess, me.resultResponseSchedaRelazioneSanitariaSituazioneGeneraleError);
        },

        resultResponseSchedaRelazioneSanitariaSituazioneGeneraleSuccess(response) {
            let me = this;
            me.jsonDataSituazioneGenerale = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaSituazioneGeneraleError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataSituazioneGenerale = {
                id: null,
                idAccettazione: this.idAccettazione,
                colloquioAvvenutoCon: "",
                cittadinanza: "",
                statoCivile: "",
                eventualeDomicilio: "",
                familiareRiferimento: "",
                posizioneGiuridica: "",
                personaIncaricata: "",
                provvedimentiPenali: "",
                composizioneNucleoFamiliare: "",
                situazioneAbitativa: "",
            };
        },

        onSituazioneGenerale() {
            let me = this;
            me.jsonDataSituazioneGenerale.idAccettazione = me.idAccettazione;
            if (!me.jsonDataSituazioneGenerale.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaSituazioneGenerale, me.jsonDataSituazioneGenerale, me.saveSchedaRelazioneSanitariaSituazioneGeneraleSuccessResponse, me.saveSchedaRelazioneSanitariaSituazioneGeneraleErrorResponse);
        },
        saveSchedaRelazioneSanitariaSituazioneGeneraleSuccessResponse() {},
        saveSchedaRelazioneSanitariaSituazioneGeneraleErrorResponse() {
            console.error("Errore nel salvataggio situazione generale :");
        },
    },
};
</script>
